import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'seo-logged_out_brand_tab-scroll';
/**
 * Tracks the horizontal scrolling of the logged-out brand C2 Tabs component. The parameters represent the following:
- 2: LeftScrollPercent: Tracks the extent (as a percentage) that the left-side of the Tabs has been scrolled (0 represents not scrolled at all).
- 3: RightScrollPercent: Tracks the extent (as a percentage) that the right-side of the Tabs has been scrolled. (1.0 represents fully scrolled to end).
- 4: ScrolledToEnd: Returns a boolean true if the user has scrolled to end (RightScrollPercent &gt; 0.95 scrolled).
*/
export function trackSeoLoggedOutBrandTabScroll(brandToken, LeftScrollPercent, RightScrollPercent2, ScrolledToEnd3) {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
        parameters: {
            brandToken,
            LeftScrollPercent,
            RightScrollPercent2,
            ScrolledToEnd3,
        },
    });
}
